<template>
  <div class="button-group">
    <button @click="modificar" class="btn btn-sm btn-warning">Modificar</button>
    <button @click="eliminar" class="btn btn-sm btn-danger">Eliminar</button>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import { get } from "lodash-es";

export default Vue.extend({
  name: "EmpresasTablaActions",
  methods: {
    async modificar() {
      const resp = await axios.post("/execute", {
        method: "CLI.GetEmpresaDeClienteByEmpresaId",
        parameters: [
          {
            name: "id_empresa",
            value: this.params.data.id_empresa,
          },
        ],
      });
      if (resp.data.ok) {
        this.$store.commit(
          "Empresas/setEmpresaForUpdate",
          get(resp.data, "result[0][0]", ""),
        );
      } else {
        this.$msgBoxOk(`Error al traer datos de empresa :${resp.data.message}`);
      }

      this.$bvModal.show("modificarEmpresaModal");
    },
    eliminar() {
      this.$bvModal
        .msgBoxConfirm(
          "Estas seguro de eliminar la empresa? No se puede deshacer",
        )
        .then(async () => {
          const { data } = await axios.delete(
            `/empresas/${this.params.data.id_empresa}`,
          );
          if (data.ok) {
            await this.$store.dispatch(
              "Empresas/getEmpresas",
              this.$route.params.id_cliente,
            );
            this.$bvToast.toast(data.message, { variant: "success" });
          } else {
            this.$bvToast.toast(data.message, { variant: "danger" });
          }
        });
    },
  },
});
</script>

<style scoped></style>
